export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/src/identity.js
// module id = 412
// module chunks = 0